"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTransaction = void 0;
const common_1 = require("../../common");
const models_1 = require("../../products/models");
const models_2 = require("../../setup/models");
const enums_1 = require("../enums");
class ProductTransaction extends common_1.MongoDocument {
}
exports.ProductTransaction = ProductTransaction;
//# sourceMappingURL=product-transaction.model.js.map